// extracted by mini-css-extract-plugin
var _1 = "panel--cukWHbVo";
var _2 = "userItem--hOO_q48L";
export { _1 as "panel", _2 as "userItem" }
